var app = angular.module("leonardo");

var ImageCrop = function($scope, $timeout, CropperService) {
  var file, data;
  $scope.file = $scope.ngDialogData.file ? $scope.ngDialogData.file : '';

  $scope.options = {
    maximize: true,
    //aspectRatio: 20 / 13,
    guides: false,
    viewMode: 0,
    movable: false,
    crop: function(dataNew) {
      data = dataNew.detail;
    }
  };

  $scope.submit = function() {
    if (!file || !data) {
      return;
    }
    CropperService.crop(file, data).then(CropperService.encode).then(function(dataUrl) {
      var array_file = dataUrl.split('base64,');
      var type = array_file[0].split('data:');
      var blob = $scope.b64toBlob(array_file[1], type[1].slice(0, -1));
      blob.name = $scope.file.name;
      $scope.confirm(blob);
    });
  };

  $scope.b64toBlob = function(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, {type: contentType});
  };

  $scope.handleFileSelect=function(blob) {
    file = blob;
    var reader = new FileReader();
    reader.onload = function (evt) {
      $scope.$apply(function(){
        $scope.myFile=evt.target.result;
      });
    };
    reader.readAsDataURL(blob);
  };

  $scope.$watch('file', function(newValue) {
    $scope.handleFileSelect(newValue);
    $timeout(function(){
      var image = document.getElementById('image-crop');
      $scope.cropper = new Cropper(image, $scope.options);
    },100);
  });

};

app.controller('ImageCrop', ['$scope', '$timeout', 'CropperService', ImageCrop]);
